// extracted by mini-css-extract-plugin
export default {"wrapper":"ZSZY1phv","slide":"vCCqOvOq","button":"XIxoy7tw","content":"ISsYr_9r","caretIcon":"n9NILyEi"};